import { useNavigate } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';

const Card = ({ id, image, title }) => {
  const navigate = useNavigate();
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  // Use default image if image is not provided
  const displayImage = image || '/images/default-questionnaire.jpg';

  return (
    <div className="group relative bg-zinc-900/95 rounded-3xl overflow-hidden cursor-pointer 
      transform transition-all duration-500 hover:scale-[1.02] hover:shadow-xl">
      <div className="relative aspect-[1.5/1]">
        <img
          ref={ref}
          src={inView ? displayImage : undefined}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 
            group-hover:scale-105"
          loading="lazy"
          onError={(e) => {
            e.target.src = '/images/default-questionnaire.jpg';
          }}
        />
        
        <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/50 to-black/80 
          transition-opacity duration-300">
          <div className="absolute inset-0 p-6 flex flex-col justify-between">
            <div className="space-y-2">
              <h2 className="text-2xl text-white/90 font-bold tracking-wide leading-snug 
                line-clamp-2">{title}</h2>
            </div>

            <div className="transform translate-y-4 transition-transform duration-300 m-2
              group-hover:translate-y-0">
              <button
                onClick={() => navigate(`/questionnaire/${id}`)}
                className="flex items-center gap-2 px-4 py-2 
                  bg-white/90 rounded-full text-zinc-900 text-sm font-medium
                  transition-all duration-300 hover:bg-white"
              >
                <span>مشاهده بیشتر</span>
                <svg 
                  className="w-4 h-4 rotate-180" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" 
                    d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;